import { useCustomReducer } from '../../../../base/customHooks'
import IPButton from '../../../../components/IPButton'
import { useEffect, useMemo, useState } from 'react'
import '../AccountSummary/AccountSummary.scss'
import { GetProvizyonApi } from './services/getProvizyonApi'
import Swal from 'sweetalert2'
import { GetLogRequest, GetProvizyonRequest, SapProvizyonGroupedResponseModel, SapProvizyonItemModel } from './models'
import InputCampaign from '../../../../components/InputCampaign'
import IPSelectBox from '../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../components/IPSelectBox/IPSelectBox'
import IPCheckbox from '../../../../components/IPCheckBox'
import { exportToXLSX, exportToXLSXVDF, exportToXLSXVDFMultipleColumns, formatCurrencyTemlik, formatDate } from '../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'
import { InsertLogApi } from './services/insertLogApi'
import Table from '../../../../components/Table'
import IPExcelButton from '../../../../components/IPExcelButton'
import IPModal from '../../../../components/IPModal'
import { GetVodafonePKRequest, GetVodafonePKResponse } from '../VodafonePKDealer/models/model'
import { GetPKListApi } from '../VodafonePKDealer/services/getPKListApi'
import moment from 'moment'
interface IProvizyonState {
  selectedType: ISelectOption
}

function Provizyon(props: BaseComponentWithContextProps) {
  const getInitialState = (): IProvizyonState => {
    return {
      selectedType: props.user.IsVodafone ? { value: 'B', label: 'Bekleyen' } : { label: 'Hepsi', value: 'H' },
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IProvizyonState>(intialState)
  const [provData, setProvData] = useState<SapProvizyonGroupedResponseModel[]>([])
  const [detailModal, setDetailModal] = useState<SapProvizyonItemModel[] | null>(null)
  const [openModal, setModalOpen] = useState(false)
  const [openModalPK, setModalOpenPK] = useState(false)
  const [pkData, setPkData] = useState<GetVodafonePKResponse[]>([])

  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  props.user.IsVodafone && inititalStartDate.setMonth(8)
  props.user.IsVodafone && inititalStartDate.setFullYear(2025)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [currentPage, setCurrentPage] = useState(0)

  const getProv = async () => {
    const req: GetProvizyonRequest = {
      Baslangic: formatDate(startDate),
      Bitis: formatDate(endDate),
      Type: state.selectedType.value.toString(),
    }
    props.showLoading()
    const getProvizyon: GetProvizyonApi = new GetProvizyonApi({})
    getProvizyon
      .getProvizyon(req)
      .then(result => {
        if (result) {
          setProvData(result)
          props.hideLoading()
        } else {
          console.warn('Provizyon result is empty.')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'Provizyon bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  useEffect(() => {
    if (props.user.IsVodafone)
      getProv()
  }, [])

  const typeOptions = [
    { value: 'H', label: 'Hepsi' },
    { value: 'F', label: 'Faturalanmış' },
    { value: 'B', label: 'Bekleyen' },
  ]

  const faturaKes = async (checked: boolean, belNo: string) => {
    const req: GetLogRequest = {
      Check: checked,
      BelNo: belNo,
      Type: "Provizyon"
    }
    props.showLoading()
    const insertLog: InsertLogApi = new InsertLogApi({})
    insertLog
      .insertLogApi(req)
      .then(result => {
        if (result) {
          setProvData(prevData =>
            prevData.map(item =>
              item.ProvizyonBelgesi === belNo
                ? { ...item, FaturaKestim: checked }
                : item
            )
          )
          props.hideLoading()
        } else {
          console.warn('Log error')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'Provizyon bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  const openDetailModal = (items: SapProvizyonItemModel[]) => {
    setDetailModal(items)
    setModalOpen(true)
  }

  const openDetailModalPK = (belgeNo: string) => {
    getPK(belgeNo)
  }

  const getPK = async (belgeNo: string) => {
    console.log(props.user)
    const req: GetVodafonePKRequest = {
      BelgeNo: belgeNo,
    }
    props.showLoading()
    const getPoDoc: GetPKListApi = new GetPKListApi({})
    getPoDoc
      .getPKList(req)
      .then(result => {
        if (result) {
          setPkData(result)

          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'PK verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          else
            setModalOpenPK(true)
          props.hideLoading()
        } else {
          console.warn('PK result is empty.')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'PK verisi bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  const saveExcel = (items: SapProvizyonItemModel[] | null) => {
    try {
      if (items && items.length > 0) {
        const data: any[] = []
        items.forEach((item, index) => {
          data.push({
            'Kayıt Tarihi': '',
            'İşlem No': '',
            'Aktivasyon Tarihi': item.SUBSC_CONT_DATE || '',
            IMEI: item.IMEI || '',
            'Ürün Açıklaması': item.MAKTX || '',
            'Virman Tutarı': formatCurrencyTemlik(item.DEALER_PURC_PRICE),
            'VDF Cari Kodu': item.PAYABLE_BRANCH_CODE?.slice(0, 7) || '',
            'Alt Bayi Kodu': item.ACTIVATION_SHOP_CODE || '',
            'Aktivasyon Türü': item.CCB_CAMPAIGN_CODE || '',
            'Ürün Tipi': item.ACCESSORY_CODE || '',
            'VDF Ürün Kodu': item.HANDSET_CODE || '',
            'Üretici Kodu': item.BISMT || '',
          })
        })
        exportToXLSXVDF(data, 'Provizyon Detay', 'F')
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description || 'Bir hata oluştu',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  // Tablo başlıkları
  const columnDefinitions = [
    { Header: 'Fatura Kestim', accessor: 'col1' },
    { Header: 'Provizyon Belgesi', accessor: 'col2' },
    { Header: 'Tarih', accessor: 'col4' },
    { Header: 'Tutar', accessor: 'col5' },
    { Header: 'KDV', accessor: 'col6' },
    { Header: "KDV'li Tutar", accessor: 'col7' },
    { Header: "Kalan", accessor: 'colkalan' },
    { Header: 'Prim Tipi', accessor: 'col8' },
    { Header: 'Açıklama', accessor: 'col9' },
    { Header: 'Fatura Durumu', accessor: 'col10' },
    { Header: 'Fatura Referans', accessor: 'col3' },
    { Header: 'Fatura No', accessor: 'col11' },
  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableDataAndTotal = useMemo(() => {
    let totalWithKdv = 0
    const tableData = provData.map(item => {
      const cleanedTotalWithKdv = item.TutarKDVLi.replace(/\./g, '').replace(',', '.')
      const TotalWithKdv = parseFloat(cleanedTotalWithKdv)

      const data = {
        col1: (
          <IPCheckbox
            label=''
            onCheckedChange={(checked: boolean) => faturaKes(checked, item.ProvizyonBelgesi)}
            checked={item.FaturaKestim}
          />
        ),
        col2: (
          <b
            style={{
              cursor: ['A3', 'A5', 'A6', 'A7', 'A8'].includes(item.POType) ? 'pointer' : '',
              color: ['A3', 'A5', 'A6', 'A7', 'A8'].includes(item.POType) ? 'blue' : 'black',
              textDecoration: ['A3', 'A5', 'A6', 'A7', 'A8'].includes(item.POType) ? 'underline' : 'none',
            }}
            onClick={() => {
              if (['A3', 'A5', 'A6', 'A7'].includes(item.POType)) {
                openDetailModal(item.Items)
              }
              else if (['A8'].includes(item.POType)) {
                openDetailModalPK(item.ProvizyonBelgesi)
              }
            }}
          >
            {item.ProvizyonBelgesi}
          </b>
        ),
        col3: item.ProvizyonReferans,
        col4: item.Tarih,
        col5: item.Tutar,
        col6: item.KDV,
        col7: item.TutarKDVLi,
        colkalan: item.KALAN,
        col8: ['A3', 'A5', 'A6', 'A7'].includes(item.POType) ? 'Temlik' : item.PrimTipi,
        col9: ['A3', 'A5', 'A6', 'A7'].includes(item.POType) ? 'VDF Kampanya Destek Bedeli' : item.Aciklama,
        col10: item.FaturaDurumu,
        col11: item.FaturaNo,
      }
      if (!isNaN(TotalWithKdv)) {
        totalWithKdv += TotalWithKdv
      }
      return data
    })
    return {
      tableData,
      totalWithKdv,
    }
  }, [provData])

  const toNumberTR = (s) => {
    if (s == null) return 0;
    return Number(
      String(s)
        .trim()
        .replace(/\./g, '')   // binlik ayırıcıların hepsi
        .replace(',', '.')    // ondalık ayırıcı
    );
  };

  const excelButton = async () => {
    try {
      if (provData) {
        const data: any[] = []
        if (provData.length > 0) {
          provData.map((item, index) => {
            return data.push({
              Sıra: index + 1,
              'Fatura Kestim': item.FaturaKestim ? 'Evet' : 'Hayır',
              'Provizyon Belgesi': item.ProvizyonBelgesi,
              Tarih: item.Tarih,
              Tutar: toNumberTR(item.Tutar).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              KDV: toNumberTR(item.KDV).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              "KDV'li Tutar": toNumberTR(item.TutarKDVLi).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              "Kalan": toNumberTR(item.KALAN).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              'Prim Tipi': ['A3', 'A5', 'A6', 'A7'].includes(item.POType) ? 'Temlik' : item.PrimTipi,
              Açıklama: ['A3', 'A5', 'A6', 'A7'].includes(item.POType) ? 'VDF Kampanya Destek Bedeli' : item.Aciklama,
              'Fatura Durumu': item.FaturaDurumu,
              'Fatura Referans': item.ProvizyonReferans,
              'Fatura No': item.FaturaNo,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSXVDFMultipleColumns(data, 'Provizyon Hakediş', 'E,F,G,H')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Provizyon Fatura Takip</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>
      <form>
        <div className='form-row justify-content-center'>
          <div className='form-group col-md-3'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label={'Başlangıç Tarihi'}
              //value={values.dateStart}
              value={toDateTimeLocal(startDate)}
              onChange={e => getDate(e.target.value, 'Start')}
              isActive
            />
          </div>
          <div className='form-group col-md-3'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label={'Bitiş Tarihi'}
              //value={values.endDate}
              value={toDateTimeLocal(endDate)}
              onChange={e => getDate(e.target.value, 'End')}
              isActive
            />
          </div>
          <div className='form-group col-md-3'>
            <div className='labeltext'>
              <IPSelectBox
                name='Type'
                value={state.selectedType}
                options={typeOptions}
                onChangeSingle={option => {
                  setState({ selectedType: option })
                }}
              />
            </div>
          </div>
          <div className='form-group col-md-3'>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getProv()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
      </form>
      <div className='m-4'>
        <b style={{ color: 'red' }}>PO numarasının fatura açıklamasına ve faturadaki sipariş no kısmına mutlaka yazılması gerekmektedir.</b>
        <br></br><br></br>
        <Table
          columns={tableColumns}
          data={tableDataAndTotal.tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          headerName={`İşlem Tarihi Aralığı: ${new Date(startDate).toLocaleDateString()} - ${new Date(
            endDate
          ).toLocaleDateString()} ---TOPLAM KDV'li TUTAR: ${tableDataAndTotal.totalWithKdv
            .toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺'
            }`}
          columnCount={13}
          backgroundColor='red'
          color='white'
        />
      </div>

      <IPModal
        show={openModal}
        onClose={() => setModalOpen(false)}
        hideConfirm={true}
        width={'auto'}
        title={'Provizyon Belgesi Detay'}
        excelButton={true}
        onExcel={() => saveExcel(detailModal)}
      >
        <>
          {detailModal && (
            <div style={{ maxHeight: '750px', overflowY: 'auto' }}>
              <table className="table table-borderless table-responsive d-sm-block d-lg-table table-hover">
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 2 }}>
                  <tr className="EInvoicetableDescription">
                    <td scope="col"><div style={{ textAlign: 'center' }}>Aktivasyon Tarihi</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>IMEI</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Ürün Açıklaması</div></td>
                    <td scope="col"><div style={{ textAlign: 'right' }}>Virman Tutarı</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>VDF Cari Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Alt Bayi Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'center' }}>Aktivasyon Türü</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Ürün Tipi</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>VDF Ürün Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Üretici Kodu</div></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {(detailModal as SapProvizyonItemModel[]).map((r, idx) => (
                    <tr key={idx}>
                      <td><div style={{ textAlign: 'left' }}>{r.SUBSC_CONT_DATE || ''}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.IMEI}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.MAKTX}</div></td>
                      <td><div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(r.DEALER_PURC_PRICE) + " ₺"}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.PAYABLE_BRANCH_CODE?.slice(0, 7)}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.ACTIVATION_SHOP_CODE}</div></td>
                      <td><div style={{ textAlign: 'center' }}>{r.CCB_CAMPAIGN_CODE}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.ACCESSORY_CODE}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.HANDSET_CODE}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.BISMT}</div></td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      </IPModal>

      <IPModal
        show={openModalPK}
        onClose={() => setModalOpenPK(false)}
        hideConfirm={true}
        width={1800}
        title={'Provizyon Belgesi Detay'}
        excelButton={false}
      >
        <>
          {pkData && (
            <div style={{ maxHeight: '750px', overflowY: 'auto' }}>
              <table className="table table-borderless table-responsive d-sm-block d-lg-table table-hover">
                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 2 }}>
                  <tr className="EInvoicetableDescription">
                    <td scope="col"><div style={{ textAlign: 'left' }}>IMEI</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Belge No</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Tarih</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Dönem</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Malzeme No</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Model</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Ürün Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Ürün Adı</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>VDF Ürün Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'right' }}>Fiyat</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>VDF Cari Kodu</div></td>
                    <td scope="col"><div style={{ textAlign: 'left' }}>Şube</div></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {(pkData).map((r, idx) => (
                    <tr key={idx}>
                      <td><div style={{ textAlign: 'left' }}>{r.IMEI}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.BELGE_NO}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.TARIH ? moment(r.TARIH).format('DD.MM.YYYY') : r.TARIH}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.DONEM}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.MALZEME_NO}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.MODEL}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.URUN_KODU}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.URUN_ADI}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.VDF_URUN_KODU}</div></td>
                      <td><div style={{ textAlign: 'right' }}>{r.FIYAT}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.VDF_CARI}</div></td>
                      <td><div style={{ textAlign: 'left' }}>{r.SUBE}</div></td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      </IPModal>
    </div>
  )
}
export default componentWithContext(Provizyon)
